exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".information {\n  margin: 1rem 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/manage/domains/styles.scss
// module id = 1370
// module chunks = 0